// import {
//   Box,
//   Typography,
//   Chip,
//   Stack,
//   useTheme,
// } from "@mui/material";

// const technologies = [
//   "Flutter",
//   "React",
//   "React Native",
//   "Swift",
//   "Kotlin",
//   "Node.js",
//   "TypeScript",
//   "Next.js",
//   "MongoDB",
//   "PostgreSQL",
//   "Firebase",
//   "AWS",
// ];

// const experienceLevels = [
//   "Junior (1-3 years)",
//   "Mid-level (4-6 years)",
//   "Senior (7+ years)",
// ];

// const platforms = ["Web", "Mobile", "Cross-platform", "Full-stack"];

// const DeveloperFilters = ({ filters, setFilters }) => {
//   const theme = useTheme();

//   const handleToggle = (category, value) => {
//     const alreadySelected = filters[category].includes(value);

//     setFilters((prev) => ({
//       ...prev,
//       [category]: alreadySelected
//         ? prev[category].filter((item) => item !== value)
//         : [...prev[category], value],
//     }));
//   };

//   const renderChips = (items, category) =>
//     items.map((item) => {
//       const isActive = filters[category].includes(item);

//       return (
//         <Chip
//           key={item}
//           label={item}
//           clickable
//           onClick={() => handleToggle(category, item)}
//           sx={{
//             borderRadius: "20px",
//             fontWeight: 500,
//             backgroundColor: isActive
//               ? theme.palette.success.light
//               : "#f1f5f9",
//             color: isActive
//               ? theme.palette.success.dark
//               : "#334155",
//             border: isActive
//               ? `1px solid ${theme.palette.success.main}`
//               : "1px solid #e2e8f0",
//             "&:hover": {
//               backgroundColor: isActive
//                 ? theme.palette.success.light
//                 : "#e2e8f0",
//             },
//           }}
//         />
//       );
//     });

//   return (
//     <Box
//       sx={{
//         mt: 4,
//         p: 4,
//         borderRadius: 3,
//         backgroundColor: "#fff",
//         border: "1px solid #e2e8f0",
//       }}
//     >
//       {/* Technologies */}
//       <Box mb={3}>
//         <Typography fontWeight={600} mb={2}>
//           Technologies
//         </Typography>
//         <Stack direction="row" spacing={1} flexWrap="wrap" gap={1}>
//           {renderChips(technologies, "technologies")}
//         </Stack>
//       </Box>

//       {/* Experience */}
//       <Box mb={3}>
//         <Typography fontWeight={600} mb={2}>
//           Experience Level
//         </Typography>
//         <Stack direction="row" spacing={1} flexWrap="wrap" gap={1}>
//           {renderChips(experienceLevels, "experience")}
//         </Stack>
//       </Box>

//       {/* Platform */}
//       <Box>
//         <Typography fontWeight={600} mb={2}>
//           Platform
//         </Typography>
//         <Stack direction="row" spacing={1} flexWrap="wrap" gap={1}>
//           {renderChips(platforms, "platform")}
//         </Stack>
//       </Box>
//     </Box>
//   );
// };

// export default DeveloperFilters;

import { Box, Typography, Chip, Stack, useTheme } from "@mui/material";

const experienceLevels = [
  "Junior (1-3 years)",
  "Mid-level (4-6 years)",
  "Senior (7+ years)",
];

const platforms = ["Web", "Mobile", "Cross-platform", "Full-stack"];

const DeveloperFilters = ({ filters, setFilters, technologies = [] }) => {
  const theme = useTheme();

  const handleToggle = (category, value) => {
    const alreadySelected = filters[category].includes(value);
    setFilters((prev) => ({
      ...prev,
      [category]: alreadySelected
        ? prev[category].filter((item) => item !== value)
        : [...prev[category], value],
    }));
  };

  const renderChips = (items, category) =>
    items.map((item) => {
      const isActive = filters[category].includes(item);
      return (
        <Chip
          key={item}
          label={item}
          clickable
          onClick={() => handleToggle(category, item)}
          sx={{
            borderRadius: "20px",
            fontWeight: 500,
            backgroundColor: isActive ? theme.palette.success.light : "#f1f5f9",
            color: isActive ? theme.palette.success.dark : "#334155",
            border: isActive
              ? `1px solid ${theme.palette.success.main}`
              : "1px solid #e2e8f0",
            "&:hover": {
              backgroundColor: isActive
                ? theme.palette.success.light
                : "#e2e8f0",
            },
          }}
        />
      );
    });

  return (
    <Box
      sx={{
        mt: 4,
        p: 4,
        borderRadius: 3,
        backgroundColor: "#fff",
        border: "1px solid #e2e8f0",
      }}
    >
      {/* Technologies — dynamic from API */}
      <Box mb={3}>
        <Typography fontWeight={600} mb={2}>
          Technologies
        </Typography>
        {technologies.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            Loading technologies...
          </Typography>
        ) : (
          <Stack direction="row" spacing={1} flexWrap="wrap" gap={1}>
            {renderChips(technologies, "technologies")}
          </Stack>
        )}
      </Box>

      {/* Experience */}
      <Box mb={3}>
        <Typography fontWeight={600} mb={2}>
          Experience Level
        </Typography>
        <Stack direction="row" spacing={1} flexWrap="wrap" gap={1}>
          {renderChips(experienceLevels, "experience")}
        </Stack>
      </Box>

      {/* Platform — kept as-is, UI only */}
      {/* <Box>
        <Typography fontWeight={600} mb={2}>
          Platform
        </Typography>
        <Stack direction="row" spacing={1} flexWrap="wrap" gap={1}>
          {renderChips(platforms, "platform")}
        </Stack>
      </Box> */}
    </Box>
  );
};

export default DeveloperFilters;